module.exports = __webpack_public_path__ + "assets/img/Cluey-Learning-1-Landing-Page-+-Website-w540.c505b9ab.webp";